"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateDesign = updateDesign;
const either_1 = require("../../types/either");
const designs_1 = require("../designs");
const Product_1 = require("../../models/Product");
const layers_1 = require("../layers");
/**
 * Updates the printable design id in place and returns the designs found for the left (or full) page and right (optional) page
 */
function updateDesign(_ref) {
  let {
    printable,
    designId,
    newTemplate,
    oldTemplate,
    printableGroupType,
    interiorPageCount,
    hammerCategory
  } = _ref;
  switch (printableGroupType) {
    case 'wooden-box':
      return handleWoodenBoxDesignUpdate({
        printable,
        newTemplate
      });
    case 'cover':
      return handleCoverDesignUpdate({
        printable,
        designId,
        newTemplate,
        interiorPageCount,
        hammerCategory
      });
    default:
      return handleDesignUpdate({
        printable,
        designId,
        newTemplate,
        oldTemplate,
        interiorPageCount,
        hammerCategory
      });
  }
}
function handleWoodenBoxDesignUpdate(_ref2) {
  let {
    printable,
    newTemplate
  } = _ref2;
  var _a;
  const woodBoxDesign = (_a = newTemplate.woodenBox) === null || _a === void 0 ? void 0 : _a.design;
  if (!woodBoxDesign) {
    return (0, either_1.left)(new Error('Could not update wooden-box printable: No wooden box design found in template'));
  }
  printable.designId = woodBoxDesign.id;
  return (0, either_1.right)({
    leftDesign: woodBoxDesign,
    rightDesign: undefined
  });
}
function handleCoverDesignUpdate(_ref3) {
  let {
    printable,
    designId,
    newTemplate,
    interiorPageCount,
    hammerCategory
  } = _ref3;
  const interiorPrintableCount = (0, Product_1.isSpreadBooksCategory)(hammerCategory) ? interiorPageCount / 2 : interiorPageCount;
  const findCoverDesignResult = (0, designs_1.findCoverDesign)(newTemplate.designs, interiorPrintableCount, designId);
  if (findCoverDesignResult.isLeft()) {
    return (0, either_1.left)(findCoverDesignResult.value);
  }
  printable.designId = findCoverDesignResult.value.id;
  return (0, either_1.right)({
    leftDesign: findCoverDesignResult.value,
    rightDesign: undefined
  });
}
function handleDesignUpdate(_ref4) {
  let {
    printable,
    designId,
    newTemplate,
    oldTemplate,
    interiorPageCount,
    hammerCategory
  } = _ref4;
  const newTemplateDesigns = newTemplate.designs;
  const oldTemplateDesigns = oldTemplate.designs;
  // Left design is always present as it represents either the left "page" in a composite design spread book
  // or the full spread design in a spread book or the only design in page books or other product such as prints or frames
  const [leftDesignId, rightDesignId] = printable.designId.split('|');
  const leftFindMatchingOrDefaultDesignResult = (0, designs_1.findMatchingOrDefaultDesign)({
    newTemplateDesigns,
    oldTemplateDesigns,
    designId: leftDesignId || designId,
    interiorPageCount: (0, Product_1.isSpreadBooksCategory)(hammerCategory) ? interiorPageCount / 2 : interiorPageCount
  });
  if (leftFindMatchingOrDefaultDesignResult.isLeft()) {
    return (0, either_1.left)(leftFindMatchingOrDefaultDesignResult.value);
  }
  const leftDesign = leftFindMatchingOrDefaultDesignResult.value;
  // Right design is therefore optional, as it only represents the right "page" design in spread book products where a composite design is selected
  let rightDesign;
  let rightFindMatchingOrDefaultDesignResult;
  if (rightDesignId && leftDesign.coverage !== layers_1.CoverageType.FULL) {
    rightFindMatchingOrDefaultDesignResult = (0, designs_1.findMatchingOrDefaultDesign)({
      newTemplateDesigns,
      oldTemplateDesigns,
      designId: rightDesignId || designId,
      interiorPageCount: (0, Product_1.isSpreadBooksCategory)(hammerCategory) ? interiorPageCount / 2 : interiorPageCount
    });
    if (rightFindMatchingOrDefaultDesignResult.isLeft()) {
      return (0, either_1.left)(rightFindMatchingOrDefaultDesignResult.value);
    }
    rightDesign = rightFindMatchingOrDefaultDesignResult.value;
    if (rightDesign.coverage === layers_1.CoverageType.FULL) {
      // If we've moved to a new template where the former right design has become full coverage, we should just replicate the left design on the right
      // as there is no room for a full coverage design on the right page
      rightDesign = leftDesign;
    }
  }
  printable.designId = leftDesign.id;
  printable.isCompositeDesign = false;
  if (rightDesign) {
    // If we have a composite design selected on a spread book, the composite design id is represented as
    // left design id | right design id
    printable.designId = `${leftDesign.id}|${rightDesign.id}`;
    printable.isCompositeDesign = true;
  }
  return (0, either_1.right)({
    leftDesign,
    rightDesign
  });
}